import clsx from 'clsx';
import { ReactNode, useMemo } from 'react';

import styles from './ModuleAnnotationsStyles.css';

type LayoutProps = { layout: number; children: ReactNode };

export const DivLayout = ({ layout, children }: LayoutProps) => {
  const cls = useMemo(
    () =>
      clsx('d-flex c-module__content', {
        'flex-row': layout === 0,
        'flex-row-reverse': layout === 1,
        'flex-column': layout === 2,
        'flex-column-reverse': layout === 3,
        'u-margin-left-negative-md u-margin-right-negative-md': layout === 0 || layout === 1,
      }),
    [layout],
  );
  return <div className={cls}>{children}</div>;
};

export const DivAnnotations = ({ layout, children }: LayoutProps) => {
  const cls = useMemo(
    () =>
      clsx('relative', {
        'col col-4': layout === 0 || layout === 1,
        'pl-2': layout === 0,
        'pr-0': layout === 1,
        'pt-1': layout === 0 || layout === 1 || layout === 2,
        'pb-1': layout === 3,
        [styles.listFlexContainer]: layout === 2 || layout === 3,
      }),
    [layout],
  );
  return <div className={cls}>{children}</div>;
};

export const DivImage = ({ layout, children }: LayoutProps) => {
  const cls = useMemo(
    () =>
      clsx('relative', {
        'col col-8': layout === 0 || layout === 1,
      }),
    [layout],
  );
  return <div className={cls}>{children}</div>;
};
